import { useState } from 'react';
import { useNavigate } from 'react-router';

import styles from '../styles.module.css';
import { statusContainer, TurbineForm } from './turbineForm';
import {
  parseTurbineSchema,
  createTurbineSchema,
  modelOptions,
  turbineTypeOptions
} from './utils';
import ConfirmIcon from '@/assets/icons/success-icon.svg?react';
import TurbineIcon from '@/assets/icons/turbine.svg?react';
import {
  AdminCardButtons,
  AdminCardHeader
} from '@/components/AdminToolComponents/card';
import { Button } from '@/components/Form/Button';
import useModal from '@/context/ModalContext/useModal';
import {
  useCreateUpdateTurbine,
  type TurbineFormData
} from '@/hooks/services/Turbines';

const NewTurbine = () => {
  const navigate = useNavigate();
  const { showTypedModal, closeModal } = useModal();
  const { mutate: saveTurbine, isPending: isSaving } =
    useCreateUpdateTurbine('create');

  const [formErrors, setFormErrors] = useState<{ [k: string]: string }>({});
  const [formData, setFormData] = useState<TurbineFormData>({
    id: '',
    serialNumber: '',
    name: '',
    brand: '',
    model: modelOptions[0],
    turbineType: turbineTypeOptions[0],
    maxCapacity: '',
    manufacturingCountry: '',
    manufacturingYear: new Date().getFullYear().toString(),
    acquisitionYear: new Date().getFullYear().toString(),
    status: 'Active',
    isActive: true
  });

  const handleChangeFormData = (field: keyof TurbineFormData, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCreateConfirmation = () => {
    showTypedModal({
      type: 'success',
      title: 'Turbine was successfully created'
    });
    setTimeout(() => {
      closeModal();
      navigate('/admin-tool/turbines');
    }, 1000);
  };

  const handleSave = () => {
    const parsed = createTurbineSchema.safeParse({
      ...formData
    });

    if (!parsed.success) {
      const errs = parseTurbineSchema(parsed);
      setFormErrors(errs);
    } else {
      setFormErrors({});
      saveTurbine(formData, {
        onSuccess: () => {
          handleCreateConfirmation();
        },
        onError: error => {
          console.error('Error saving turbine:', error);
        }
      });
    }
  };

  return (
    <div className={styles.adminWrapper}>
      <div className={styles.adminContainer}>
        <AdminCardHeader
          left={
            <>
              <TurbineIcon className={styles.adminIconHeader} />
              <h2 className={styles.adminTitle}>New Turbine</h2>
            </>
          }
          right={statusContainer({
            formData,
            handleChangeFormData
          })}
        />

        <TurbineForm
          formData={formData}
          handleChangeFormData={handleChangeFormData}
          formErrors={formErrors}
          isNewTurbine={true}
        />
      </div>

      <AdminCardButtons>
        <Button
          color="blue"
          solid={false}
          onClick={() => navigate('/admin-tool/turbines')}
          disabled={isSaving}
          size="large"
          label="CANCEL"
        />
        <Button
          onClick={handleSave}
          color="blue"
          label="SAVE"
          size="large"
          loading={isSaving}
        />
      </AdminCardButtons>
    </div>
  );
};

export default NewTurbine;
